<template>
  <!-- Main content -->
  <section class="content">
    <!-- Info boxes -->
    <div class="row">
      <v-app>
        <v-content>
          <v-container fluid>
            <v-progress-circular v-show="loading" indeterminate ></v-progress-circular>
            <v-dialog v-model="dialog" width="500">
              <v-card>
                
                <v-card-text>
                 <h4> Resend Token to user? </h4>
                </v-card-text>
      
                <v-card-actions>
                  <v-btn
                    color="primary"
                    flat
                    @click="dialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    flat
                    @click="resend(item)"
                  >
                    Confirm
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-data-table
              :headers="headers"
              :items="notifications"
              class="elevation-1"
              :pagination.sync="pagination"
            >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.id }}</td>
              <td>{{ props.item.username }}</td>
              <td>
                <h6 v-if="props.item.sentStatus === 'TOKEN_SENT'"  class="primary--text body-2"> {{ props.item.sentStatus }} </h6>
                <p v-if="props.item.sentStatus === 'TOKEN_NOT_SENT'"  class="error--text body-2"> {{ props.item.sentStatus }} </p>
              </td>
              <td>{{ props.item.createdAt }}</td>
              <td> <v-btn color="primary" @click="resendToken(props.item)"> Resend </v-btn>
              </td>
             <!--  <td>
                  <v-btn v-if="props.item.systemStatus === 'UP'"  color="primary"> {{ props.item.systemStatus }} </v-btn>
                   <v-btn v-if="props.item.systemStatus === 'DOWN'"  color="red"> {{ props.item.systemStatus }} </v-btn>
              </td> -->
            </template>
            <template slot="no-data">
              <p> No data Found </p>
              <v-btn color="primary" @click="getTokenNotications">Reload</v-btn>
            </template>
           </v-data-table>

           <v-snackbar
            v-model="snackbar"
            :right="true"      
            :bottom="true"
            :color='snackColor'
          >
            {{ snackmessage }}
            <v-btn
              color="pink"
              flat
              @click="snackbar = false"
            >
              Close
            </v-btn>
          </v-snackbar>

          </v-container>
        </v-content>
      </v-app>
    </div>
    <!-- /.row -->
  </section>
  <!-- /.content -->
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'

export default {
  name: 'viewtokennotifications',
  data: function() {
    return {
      headers: [
        { text: 'id', value: 'id' },
        { text: 'Username', value: 'username' },
        { text: 'Token Sent', value: 'sentStatus' },
        { text: 'Created At', value: 'createdAt' }
      ],
      error: '',
      notifications: [],
      pagination: {sortBy: 'id', descending: true},
      snackbar: false,
      snackmessage: '',
      snackColor: '',
      dialog: false,
      item: {},
      loading: false
    }
  },
  mounted () {
    this.getTokenNotications()
  },
  methods: {
    getTokenNotications () {
      var url = config.serverURI + '/notification/get'
      var token = store.state.token
      axios.get(url, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            this.notifications = response.data
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized') {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.message = data.message
            }
          })
      return this.notifications
    },
    resendToken (item) {
      this.dialog = true
      this.item = item
    },
    resend (item) {
      this.loading = true
      let url = config.serverURI + '/notification/resendToken'
      let token = store.state.token
      axios.post(url, item, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            console.log('API Response:', response)
            this.snackbar = true
            if (response.data.error === true) {
              this.snackColor = 'error'
            } else {
              this.snackColor = 'success'
            }
            this.snackmessage = response.data.message
            this.notifications = this.getTokenNotications()
            this.loading = false
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response
            if (data.message === 'Unauthorized' || error.response.status === 401) {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.snackbar = true
              this.snackmessage = data.status
              this.snackColor = 'error'
              this.loading = false
            }
          })
      this.dialog = false
    }
  }
}

</script>
<style>
.info-box {
  cursor: pointer;
}

.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}

.fullCanvas {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// usertokennotifications.vue?7fbcdbcc